import { useNavigate } from 'react-router-dom';

interface Props {
  headline?: string;
  sub?: string;
  btn1?: string;
  btn2?: string;
  btn1Path?: string;
  btn2Path?: string;
  onBtn1Click?: () => void;
}

export default function CTAStrip({
  headline = 'Ready to Scale Your Logistics?',
  sub = 'Join hundreds of businesses that trust THL to fulfill their orders accurately, quickly, and affordably.',
  btn1 = 'Request a Quote →',
  btn2 = 'Book a Facility Tour',
  btn1Path = '/contact',
  btn2Path = '/facilities',
  onBtn1Click,
}: Props) {
  const navigate = useNavigate();

  const handleBtn1 = () => {
    if (onBtn1Click) {
      onBtn1Click();
    } else {
      navigate(btn1Path ?? '/contact');
    }
  };

  return (
    <div className="cstrip py-20 px-6">
      <div className="max-w-7xl mx-auto text-center">
        <p className="eyebrow">Get Started</p>
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">{headline}</h2>
        <p className="text-white/50 max-w-lg mx-auto mb-8 text-sm leading-relaxed">{sub}</p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <button onClick={handleBtn1} className="btn-primary">
            {btn1}
          </button>
          <button onClick={() => navigate(btn2Path ?? '/facilities')} className="btn-ghost">
            {btn2}
          </button>
        </div>
      </div>
    </div>
  );
}
